import { createRouter, createWebHistory } from 'vue-router'
import * as SentryVue from '@sentry/vue'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'home',
			component: async () => import ('@/views/Home.vue'),
		},
		{
			path: '/about',
			name: 'About',
			component: async () => import ('@/views/About.vue'),
		},
		{
			path: '/contact',
			name: 'Contact',
			component: async () => import ('@/views/Contact.vue'),
		},
		{
			path: '/search',
			name: 'Search',
			component: async () => import ('@/views/Search.vue'),
		},
		{
			path: '/legal/:id',
			name: 'Legal',
			component: async () => import ('@/views/Legal.vue'),
		},
		{
			path: '/article',
			name: 'Articles',
			component: async () => import ('@/views/Articles/Index.vue'),
		},
		{
			path: '/article/:id',
			name: 'ArticlePage',
			component: async () => import ('@/views/Articles/ArticlePage.vue'),
		},

		{
			path: '/event',
			name: 'Events',
			component: async () => import ('@/views/Events/Index.vue'),
		},
		{
			path: '/event/:id',
			name: 'EventPage',
			component: async () => import ('@/views/Events/EventPage.vue'),
		},
		{
			path: '/author',
			name: 'Authors',
			component: async () => import ('@/views/Authors/Index.vue'),
		},
		{
			path: '/author/:id',
			name: 'AuthorPage',
			component: async () => import ('@/views/Authors/AuthorPage.vue'),
		},
		{
			path: '/products',
			name: 'Products',
			component: async () => import ('@/views/Products/Index.vue'),
		},
		{
			path: '/products/:id',
			name: 'ProductPage',
			component: async () => import ('@/views/Products/ProductPage.vue'),
		},
		{
			path: '/cart',
			name: 'Cart',
			component: async () => import ('@/views/Cart.vue'),
		},
	{
		path: '/payment/:id',
		name: 'Payment',
		component: async () => import ('@/views/Payment.vue'),
	},
	{
		path: '/update-payment-method/:id',
		name: 'UpdatePaymentMethod',
		component: async () => import ('@/views/UpdatePaymentMethod.vue'),
	},
	{
		path: '/bundle/:id',
		name: 'Bundle',
		component: async () => import ('@/views/Bundle.vue'),
	},
		{
			path: '/shibolet',
			name: 'Shibolet',
			component: async () => import ('@/views/Shibolet.vue'),
		},
		{
			path: '/netanyahu1000',
			name: 'Netanyahu1000',
			component: async () => import('@/views/Netanyahu1000.vue'),
		},
		{
			path: '/upsell',
			name: 'Upsell',
			component: async () => import ('@/views/Products/Upsell.vue'),
		},
		{
			path: '/success',
			name: 'Success',
			component: async () => import ('@/views/Products/FlashSale.vue'),
		},
		{
			path: '/signup',
			name: 'Signup',
			component: async () => import ('@/views/auth/Signup.vue'),
			meta: { hideMenu: true },
		},
		{
			path: '/login',
			name: 'Login',
			component: async () => import ('@/views/auth/Login.vue'),
			meta: { hideMenu: true },
		},
		{
			path: '/forgot-password',
			name: 'ForgotPassword',
			component: async () => import ('@/views/auth/ForgotPassword.vue'),
			meta: { hideMenu: true },
		},
		{
			path: '/resetPassword',
			name: 'ResetPassword',
			component: async () => import ('@/views/auth/ResetPassword.vue'),
			meta: { hideMenu: true },
		},
		{
			// Always last route
			path: '/:catchAll(.*)*',
			name: '404',
			component: async () => import('@/views/404.vue'),
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve({
						behavior: 'smooth',
						el: to.hash
					})
				}, 500)
			})
		}
		return { top: 0, left: 0 }
	},
})

router.onError((error, to) => {
	// Report router errors to Sentry
	if (import.meta.env.VITE_SENTRY_DSN) {
		try {
			SentryVue.captureException(error)
		} catch {
			// Sentry might not be initialized yet
		}
	}
	
	if (error.message.includes('Failed to fetch dynamically imported module')) {
		Object.assign(window, { location: to.fullPath })
	}
})

export default router
